import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Wallet } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { StudentPayments } from "@/features/finance/components/student-payments";
// AUTONOMY · Layer 3: student payments contextual help.

function PaymentsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="3xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`My payments`)}
          description={t(
            msg`Your invoices in both currencies with the rate of the day. Offline payments are verified by the academy before they clear your debt.`,
          )}
          icon={Wallet}
        />
      </div>
      <div class="mt-4">
        <StudentPayments />
      </div>
    </PageContainer>
  );
}

export const paymentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/payments",
  component: withFeatureGate("billing.core", PaymentsPage),
});
